import React from 'react';
import moment from 'moment';

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  CardBody,
  InputGroup,
  Input,
  Modal,
  Button, Nav, NavItem, NavLink, TabContent,
  TabPane, Badge,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';
import { axiosGet, axiosPost } from 'util/apiConfig.js';
import Select from "react-select";
import { value } from "lodash/seq";
import "./SalesNotification.css";
import styles from "./SalesNotification.css";
import classnames from "classnames";
import Axios from 'axios';
import { CSVLink } from "react-csv";
import { buildSalesNotificationCSVRows, getRowsWithUnknownClass } from 'util/salesNotificationCsv';
import { Device } from '@twilio/voice-sdk';
import debounce from "lodash/debounce";
import AddTrialModal from 'components/AddTrialModal.jsx';
const pdfRef1 = React.createRef(null);
const pdfRef2 = React.createRef(null);
const pdfRef3 = React.createRef(null);
const pdfRef4 = React.createRef(null);
const pdfRef5 = React.createRef(null);
// import { FaPhone, FaEnvelope } from 'react-icons/fa';

const pdfRefs = {
  input1: pdfRef1,
  input2: pdfRef2,
  input3: pdfRef3,
  input4: pdfRef4,
  input5: pdfRef5,
  // Add more refs as needed
};

const USER_STATE = {
  CONNECTING: "Connecting",
  READY: "Ready",
  ON_CALL: "On call",
  OFFLINE: "Offline",
}

const WHATSAPP_TEMPLATES = [
  {
    title: 'Greeting & Class Sign-up',
    body: (name) => `Hi ${name || 'there'}, this is the Fiverkids Sales Team. We saw you signed up for a trial class! We'd love to connect and help you set everything up. Please let us know if you have a few minutes to talk today.`
  },
  {
    title: 'Missed Class Follow-up',
    body: (name) => `Hi ${name || 'there'}, we noticed you missed your trial class. No worries at all! You can easily reschedule to a better time using this link: {rescheduleUrl} - hope to see you in class soon!`
  },
  {
    title: 'Post-Trial Feedback',
    body: (name) => `Hi ${name || 'there'}, hope your child enjoyed their Fiverkids Python session! Let us know if you'd like to explore our membership plans to continue their coding journey.`
  },
  {
    title: 'Reschedule Assistance',
    body: (name) => `Hi ${name || 'there'}, this is Fiverkids support. We would be happy to assist in finding a better time slot for your child's coding trial. Please reply with your preferred day and time!`
  },
  {
    title: 'Custom Message',
    body: () => ''
  }
];
const customStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
    zIndex: 1000, // Add your custom z-index value here
  }),
};

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#fff',
    border: state.isFocused ? '1px solid #5e72e4' : '1px solid #e9ecef',
    borderRadius: '8px',
    boxShadow: state.isFocused ? '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)' : 'none',
    cursor: 'pointer',
    minHeight: '43px',
    transition: 'all 0.15s ease',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#adb5bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#525f7f',
    fontSize: '14px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#5e72e4' : state.isFocused ? '#f6f9fc' : '#fff',
    color: state.isSelected ? '#fff' : state.isFocused ? '#5e72e4' : '#525f7f',
    cursor: 'pointer',
    fontSize: '14px',
    padding: '10px 12px',
  }),
  menu: (provided) => ({
    ...provided,
    border: '1px solid #e9ecef',
    borderRadius: '8px',
    boxShadow: '0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1)',
    zIndex: 9999,
  }),
};


class SalesNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      allMessages: [],
      allSalesUser: [],
      allCounts: [],
      allNotificationStatus: [],
      duplicatesNotification: [],
      textMessage: '',
      searchNotification: '',
      nameError: false,
      notesError: false,
      emailError: false,
      mobileError: false,
      classIdError: false,
      selectedMessage: {},
      startClass: false,

      listPage: 1,
      listPageSale: 1,
      totalListPageSale: '',
      rowLimitSale: 100,
      rowLimit: 10,
      activeTab: "1",

      modalTitle: '',
      successModal: false,
      errorModal: false,
      message: '',
      editModal: false,
      editSalesModal: false,
      classList: [],
      notificationNotesModal: false,
      notificationCallModal: false,
      addModal: false,
      addTrialModal: false,
      filterTeacher: null,

      message10min: '',
      message24hr: '',
      message72hr: '',
      messageBefore10min: '',
      messageBefore24hr: '',
      pdfLinkMessage10min: '',
      pdfLinkMessageBefore10min: '',
      pdfLinkMessageBefore24hr: '',
      pdfLinkMessage24hr: '',
      pdfLinkMessage72hr: '',
      messageId: '',

      filterFromDate: null,
      filterToDate: null,
      salesUser: null,
      filterSaleUser: null,
      filterNotificationStatus: 'upcoming',
      notificationStatus: '',
      device: undefined,
      userState: USER_STATE.OFFLINE,
      messageStates: {},
      allMessageCsvData: [],
      subject10min: '',
      subject24hr: '',
      subject72hr: '',
      subjectBefore10min: '',
      subjectBefore24hr: '',
      selectedClassId: '',
      selectedSalesId: '',
      selectedRecipientName: '',
      messageChannel: 'sms', // 'sms' or 'whatsapp'
      whatsappHistory: [],
      loadingWhatsappHistory: false,
      showWhatsappHistory: false,

      directWhatsappModal: false,
      directWhatsappName: '',
      directWhatsappNumber: '',
      directWhatsappCountryCode: '+91',
      directWhatsappMessage: '',
      directWhatsappTemplateIndex: 0,
      directWhatsappClassId: '',
      directWhatsappSalesId: '',
      selectedSalesNotification: null,
    };
    this.debouncedSearch = debounce(this.getSalesNotification, 700);
  }

  openDirectWhatsapp = (selectedNotification) => {
    if (!selectedNotification) return;

    let rawNumber = selectedNotification.mobile || '';
    // Robust cleanup of twilio prefix if present
    rawNumber = rawNumber.replace(/^whatsapp:/i, '').trim();

    let countryCode = '+91'; // default prefix
    let numberOnly = rawNumber;

    if (rawNumber.startsWith('+')) {
      // Find matching country code from our supported list
      const supportedCodes = ['+91', '+1', '+44', '+61', '+65', '+971', '+64', '+33', '+49', '+81', '+82', '+60', '+62', '+852'];
      let foundCode = supportedCodes.find(code => rawNumber.startsWith(code));
      if (foundCode) {
        countryCode = foundCode;
        numberOnly = rawNumber.substring(foundCode.length);
      } else {
        const match = rawNumber.match(/^\+(\d{1,4})/);
        if (match) {
          countryCode = `+${match[1]}`;
          numberOnly = rawNumber.substring(match[0].length);
        }
      }
    } else {
      let digits = rawNumber.replace(/\D/g, '');
      if (digits.length === 10) {
        numberOnly = digits;
      } else if (digits.length > 10) {
        if (digits.startsWith('91') && digits.length === 12) {
          countryCode = '+91';
          numberOnly = digits.substring(2);
        } else if (digits.startsWith('1') && digits.length === 11) {
          countryCode = '+1';
          numberOnly = digits.substring(1);
        } else {
          numberOnly = digits;
        }
      } else {
        numberOnly = digits;
      }
    }

    // Strip out all non-digits from numberOnly for presentation
    numberOnly = numberOnly.replace(/\D/g, '');

    const defaultMsg = `Hi ${selectedNotification.name || 'there'}, this is the Fiverkids Sales Team. We saw you signed up for a trial class! We'd love to connect and help you set everything up. Please let us know if you have a few minutes to talk today.`;

    this.setState({
      directWhatsappModal: true,
      selectedSalesNotification: selectedNotification,
      directWhatsappName: selectedNotification.name || '',
      directWhatsappNumber: numberOnly,
      directWhatsappCountryCode: countryCode,
      directWhatsappMessage: defaultMsg,
      directWhatsappTemplateIndex: 0,
      directWhatsappClassId: selectedNotification.classId || '',
      directWhatsappSalesId: selectedNotification.notificationId || '',
    });
  };

  handleTemplateChange = (templateIdx) => {
    const { selectedSalesNotification } = this.state;
    const name = selectedSalesNotification ? selectedSalesNotification.name : '';
    const rescheduleUrl = selectedSalesNotification ? (selectedSalesNotification.rescheduleUrl || '') : '';

    let text = WHATSAPP_TEMPLATES[templateIdx].body(name);
    if (rescheduleUrl) {
      text = text.replace(/{rescheduleUrl}/g, rescheduleUrl);
    } else {
      text = text.replace(/{rescheduleUrl}/g, 'our booking page');
    }

    this.setState({
      directWhatsappTemplateIndex: templateIdx,
      directWhatsappMessage: text
    });
  };

  sendDirectWhatsapp = () => {
    const { directWhatsappMessage, directWhatsappNumber, directWhatsappCountryCode, directWhatsappClassId, directWhatsappSalesId, directWhatsappName } = this.state;

    if (!directWhatsappMessage || !directWhatsappMessage.trim()) {
      return alert('Please enter a message to send.');
    }
    if (!directWhatsappNumber || !directWhatsappNumber.trim()) {
      return alert('Please enter a phone number.');
    }

    const cleanNumber = directWhatsappNumber.replace(/\D/g, '');
    const fullNumber = `whatsapp:${directWhatsappCountryCode}${cleanNumber}`;

    const confirmSend = window.confirm(
      `Do you want to send this WhatsApp message to ${directWhatsappName || 'Customer'} (${directWhatsappCountryCode}${cleanNumber})?\n\n` +
      `Message: "${directWhatsappMessage}"`
    );

    if (confirmSend) {
      this.setState({ loading: true });
      const dataToSend = {
        to: fullNumber,
        message: directWhatsappMessage,
        classId: directWhatsappClassId,
        salesId: directWhatsappSalesId,
        recipientName: directWhatsappName
      };

      axiosPost('message/whatsapp/send', dataToSend)
        .then((response) => {
          if (!response.isError) {
            this.setState({
              directWhatsappModal: false,
              directWhatsappMessage: '',
              loading: false
            });
            alert('WhatsApp message sent successfully!');
          } else {
            this.setState({ loading: true });
            alert('Failed to send WhatsApp message: ' + response.message);
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.error(error);
          alert('Error sending WhatsApp message.');
        });
    }
  };

  componentDidMount() {
    let storage = localStorage.getItem('Sanga_Admin');
    storage = storage ? JSON.parse(storage) : null;
    const classId = localStorage.getItem("classId");
    this.setState(
      {
        globalClassId: classId ? classId : null,
        userId: storage && storage.userId,
        userName: storage && storage.name,
        userType: storage && storage.userType,
        newRequestList: [],
        allMessages: [],
        allMessageCsvData: [],
        allCounts: [],
        allSalesUser: [],
        teachersList: [],
      },
      () => {
        // this.callInit()
        this.getSalesNotification();
        this.getClass();
        if (storage && storage.userType === 'admin' || storage.userType === 'sub_admin' || storage.userType === 'sales_ops') {
          this.getSalesUser();
          this.getDuplicatNotification();
          this.getAllTeachers();
        }
        this.setState({
          allNotificationStatus: [
            {
              value: 'Default',
              label: 'Default',
            }, {
              value: 'Very Interested',
              label: 'Very Interested',
            }, {
              value: 'Medium Interested',
              label: 'Medium Interested',
            }, {
              value: 'Less Interested',
              label: 'Less Interested',
            }, {
              value: 'Teacher No Show',
              label: 'Teacher No Show',
            }, {
              value: 'Student No Show',
              label: 'Student No Show',
            }, {
              value: 'Cancel Class',
              label: 'Cancel Class',
            },
          ]
        });
      }
    );
  }

  getClass = () => {
    // API --
    axiosGet(`class/get-classes-list`)
      .then((response) => {
        if (!response.isError) {
          this.getNotificationMessage(response.data[0].classId);
          this.setState({
            classList: response.data || [],
            classId: response.data[0].classId,
          });
        } else {
          this.setState({
            classList: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          classList: [],
        });
      });
  };


  getAllTeachers = () => {
    const { globalClassId } = this.state;
    let teachers = [{ value: null, label: "All Coaches" }];
    let url = `teacher/list-of-all-teacher`;
    if (globalClassId) {
      url = `teacher/list-of-all-teacher/${globalClassId}`;
    }
    axiosGet(url)
      .then((response) => {
        if (!response.isError) {
          let data = response.data?.result || [];
          data.map((_data) => {
            teachers.push({ value: _data.teacherId, label: _data.name, timeZone: _data.timeZone });
          });
          this.setState({
            teachersList: teachers,
          });
        } else {
          this.setState({
            teachersList: teachers,
          });
        }
      })
      .catch((error) => {
        this.setState({
          teachersList: teachers,
        });
      });
  };

  // to get all messages -
  getSalesNotification = (search) => {
    const { listPage, filterFromDate, filterToDate, rowLimit, filterSaleUser, filterNotificationStatus = 'upcoming', searchNotification = '', notificationStatus, globalClassId } = this.state;
    let url = `sales/get-all-sales-notification/${listPage}/${rowLimit}`;
    const queryParams = [];
    if (globalClassId) {
      queryParams.push(`classId=${globalClassId}`);
    }
    if (filterFromDate && filterToDate) {
      queryParams.push(`fromDate=${filterFromDate}`);
      queryParams.push(`toDate=${filterToDate}`);
    }
    if (filterSaleUser) {
      queryParams.push(`salesUser=${filterSaleUser}`);
    }
    if (searchNotification) {
      queryParams.push(`name=${searchNotification}`);
    }
    if (notificationStatus) {
      queryParams.push(`notificationStatus=${notificationStatus}`);
    }
    if (filterNotificationStatus) {
      queryParams.push(`filterNotificationStatus=${filterNotificationStatus}`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    axiosGet(`${url}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            allMessages: response.data?.result,
            totalNewPage: response.data?.noofpage,
            allCounts: [{ status: "Completed Class", count: response.data?.totalNumberOfCompletedClass },
            { status: "No Show Teacher", count: response.data?.totalNumberOfNotShowTeacher },
            { status: "No Show Student", count: response.data?.totalNumberOfNotShowStudent },
            { status: "Converted Class", count: response.data?.totalNumberRegistered },
            { status: "Default", count: response.data?.totalNumberOfDefault },
            ],
          });
        } else {
          this.setState({
            allMessages: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          allMessages: [],
        });
        console.log(error);
      });
  };

  getSalesNotificationCSV = async () => {
    const { filterFromDate, filterToDate, filterSaleUser, filterNotificationStatus = 'upcoming', searchNotification = '', notificationStatus, globalClassId } = this.state;
    let url = `sales/get-all-sales-notification-csv`;
    const queryParams = [];
    if (globalClassId) {
      queryParams.push(`classId=${globalClassId}`);
    }
    if (filterFromDate && filterToDate) {
      queryParams.push(`fromDate=${filterFromDate}`);
      queryParams.push(`toDate=${filterToDate}`);
    }
    if (filterSaleUser) {
      queryParams.push(`salesUser=${filterSaleUser}`);
    }
    if (searchNotification) {
      queryParams.push(`name=${searchNotification}`);
    }
    if (notificationStatus) {
      queryParams.push(`notificationStatus=${notificationStatus}`);
    }
    if (filterNotificationStatus) {
      queryParams.push(`filterNotificationStatus=${filterNotificationStatus}`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    await axiosGet(`${url}`)
      .then((response) => {
        if (!response.isError) {
          const unknownClassRows = getRowsWithUnknownClass(response.data?.result, this.state.classList);
          if (unknownClassRows.length) {
            console.warn(
              '[SalesNotification CSV] Class Name left blank: classId not in active class list',
              unknownClassRows.map(({ notificationId, classId }) => ({ notificationId, classId }))
            );
          }
          this.setState({
            allMessageCsvData: response.data?.result,
          }, () => {
            document.getElementById('csvData').click();
          });
        } else {
          this.setState({
            allMessageCsvData: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          allMessageCsvData: [],
        });
        console.log(error);
      });
  };

  getSalesUser = () => {
    const { listPageSale, rowLimitSale } = this.state;
    // API -
    axiosGet(`sales/get-sales-users/${listPageSale}/${rowLimitSale}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            allSalesUser: response.data?.result,
            totalNewPageSale: response.data?.noofpage,
          });
        } else {
          this.setState({
            allSalesUser: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          allSalesUser: [],
        });
      });
  };

  getNotificationMessage = (classId) => {
    axiosGet(`sales/get-notification-message/${classId}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            message10min: response.data[0]?.message10min,
            message24hr: response.data[0]?.message24hr,
            message72hr: response.data[0]?.message72hr,
            messageBefore10min: response.data[0]?.messageBefore10min,
            messageBefore24hr: response.data[0]?.messageBefore24hr,
            subject10min: response.data[0]?.subject10min,
            subject24hr: response.data[0]?.subject24hr,
            subject72hr: response.data[0]?.subject72hr,
            subjectBefore24hr: response.data[0]?.subjectBefore24hr,
            subjectBefore10min: response.data[0]?.subjectBefore10min,
            messageId: response.data[0]?.messageId,
            pdfLinkMessage10min: response.data[0]?.pdfLinkMessage10min,
            pdfLinkMessageBefore10min: response.data[0]?.pdfLinkMessageBefore10min,
            pdfLinkMessageBefore24hr: response.data[0]?.pdfLinkMessageBefore24hr,
            pdfLinkMessage24hr: response.data[0]?.pdfLinkMessage24hr,
            pdfLinkMessage72hr: response.data[0]?.pdfLinkMessage72hr,
          });
        } else {
          this.setState({
            message10min: '',
            subject10min: '',
            subject24hr: '',
            subject72hr: '',
            subjectBefore24hr: '',
            subjectBefore10min: '',
            message24hr: '',
            message72hr: '',
            messageBefore10min: '',
            messageBefore24hr: '',
            pdfLinkMessage10min: '',
            pdfLinkMessageBefore10min: '',
            pdfLinkMessageBefore24hr: '',
            pdfLinkMessage24hr: '',
            pdfLinkMessage72hr: '',
          });
        }
      })
      .catch((error) => {
        this.setState({
          allMessages: [],
        });
        console.log(error);
      });
  };

  getDuplicatNotification = () => {
    axiosGet(`sales/get-all-duplicates-sales-notification`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            duplicatesNotification: response.data,
          });
        } else {
          this.setState({
            duplicatesNotification: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          duplicatesNotification: [],
        });
        console.log(error);
      });
  };

  addMessage = () => {
    this.setState({
      notificationModal: true,
    });
  };

  resetForm = () => {
    this.setState({
      loading: false,
      name: '',
      email: '',
      mobile: '',
      zoomLinkSales: '',
      nameError: false,
      notesError: false,
      emailError: false,
      mobileError: false,
      classIdError: false,
      isVisible: false,
      createdBy: '',
    });
  };


  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
      modalTitle: '',
      message: '',
    });
    if (state === 'notificationModal' || state === 'editModal') {
      this.resetForm();
    } else if (state === 'notificationModal') {
      this.setState({
        email: '',
        name: '',
        mobile: '',
      });
    }
  };

  changePage = (status) => {
    if (status && status === 'next') {
      this.setState({ listPage: this.state.listPage + 1 }, () =>
        this.getSalesNotification()
      );
    } else if (status && status === 'prev') {
      this.setState({ listPage: this.state.listPage - 1 }, () =>
        this.getSalesNotification()
      );
    }
  };

  changePageSale = (status) => {
    if (status && status === 'next') {
      this.setState({ listPageSale: this.state.listPageSale + 1 }, () =>
        this.getSalesUser()
      );
    } else if (status && status === 'prev') {
      this.setState({ listPageSale: this.state.listPageSale - 1 }, () =>
        this.getSalesUser()
      );
    }
  };

  changeClassMessage = (classId) => {
    this.getNotificationMessage(classId)
  }

  addOrUpdateNotification = (isCalledForEditNotification) => {
    let {
      name,
      email,
      mobile,
      selectedNotification,
      classId,
      createdBy,
      zoomLinkSales,
    } = this.state;
    !name
      ? this.setState({ nameError: true })
      : this.setState({ nameError: false });
    !email
      ? this.setState({ emailError: true })
      : this.setState({ emailError: false });
    !mobile
      ? this.setState({ mobileError: true })
      : this.setState({ mobileError: false });
    !classId
      ? this.setState({ classIdError: true })
      : this.setState({ classIdError: false });
    !createdBy
      ? this.setState({ createdByError: true })
      : this.setState({ createdByError: false });
    if (name && email && mobile && classId) {
      let dataToSend = {
        name,
        email,
        mobile,
        classId,
        createdBy,
        zoomLink: zoomLinkSales || '',
      };
      if (isCalledForEditNotification) {
        dataToSend = { ...dataToSend, ...{ notificationId: selectedNotification.notificationId } };
      }
      const endPointUrl = isCalledForEditNotification
        ? 'sales/edit-notification'
        : 'sales/add-notification';
      axiosPost(`${endPointUrl}`, dataToSend)
        .then((response) => {
          this.setState({
            editModal: false,
            selectedChapter: '',
            notificationModal: false,
            loading: false,
          });
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully saved.',
              },
              () => {
                this.resetForm();
                this.componentDidMount()
              }
            );
          } else {
            this.setState(
              {
                errorModal: true,
                modalTitle: 'Sorry!',
                message: response.message,
              },
              () => {
                this.resetForm();
              }
            );
          }
        })
        .catch((errorResponse) => {
          this.setState(
            {
              editModal: false,
              selectedChapter: '',
              notificationModal: false,
              errorModal: true,
              loading: false,
              modalTitle: 'Sorry!',
              message: errorResponse.message,
            },
            () => {
              this.resetForm();
            }
          );
        });
    }
  };

  UpdateSalesUser = () => {
    let {
      name,
      email,
      zoomLink,
      selectedUser,
      teacherId
    } = this.state;
    !name
      ? this.setState({ nameError: true })
      : this.setState({ nameError: false });
    !email
      ? this.setState({ emailError: true })
      : this.setState({ emailError: false });
    if (name && email) {
      let dataToSend = {
        name,
        email,
        zoomLink,
        userId: selectedUser.userId,
        teacherId
      };
      axiosPost(`sales/update-sales-user`, dataToSend)
        .then((response) => {
          this.setState({
            editSalesModal: false,
            loading: false,
          });
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully saved.',
              },
              () => {
                this.resetForm();
                this.componentDidMount()
              }
            );
          } else {
            this.setState(
              {
                errorModal: true,
                modalTitle: 'Sorry!',
                message: response.message,
              },
              () => {
                this.resetForm();
              }
            );
          }
        })
        .catch((errorResponse) => {
          this.setState(
            {
              editSalesModal: false,
              errorModal: true,
              loading: false,
              modalTitle: 'Sorry!',
              message: errorResponse.message,
            },
            () => {
              this.resetForm();
            }
          );
        });
    }
  };

  updateNotificationNotes = () => {
    let {
      notes,
      selectedNotification
    } = this.state;
    !notes
      ? this.setState({ notesError: true })
      : this.setState({ notesError: false })
    if (notes) {
      let dataToSend = {
        notes,
        notificationId: selectedNotification.notificationId
      };
      axiosPost(`sales/update-notification-notes`, dataToSend)
        .then((response) => {
          this.setState({
            notificationNotesModal: false,
            loading: false,
          });
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully saved.',
              },
              () => {
                this.resetForm();
                this.componentDidMount()
              }
            );
          } else {
            this.setState(
              {
                errorModal: true,
                modalTitle: 'Sorry!',
                message: response.message,
              },
              () => {
                this.resetForm();
              }
            );
          }
        })
        .catch((errorResponse) => {
          this.setState(
            {
              notificationNotesModal: false,
              errorModal: true,
              loading: false,
              modalTitle: 'Sorry!',
              message: errorResponse.message,
            },
            () => {
              this.resetForm();
            }
          );
        });
    }
  };



  editNotification = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({
      editModal: true,
      name: selectedNotification.name,
      email: selectedNotification.email,
      mobile: selectedNotification.mobile,
      classId: selectedNotification.classId,
      createdBy: selectedNotification.createdBy,
      zoomLinkSales: selectedNotification.zoomLink,
      selectedNotification
    });
  };

  editSalesUsers = (index) => {
    let { allSalesUser } = this.state;
    let selectedUser = allSalesUser[index];
    this.setState({
      editSalesModal: true,
      name: selectedUser.name,
      email: selectedUser.email,
      zoomLink: selectedUser.zoomLink,
      teacherId: selectedUser?.teacher[0]?.teacherId || '',
      selectedUser
    });
  };

  addNotes = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({
      notificationNotesModal: true,
      notes: selectedNotification.notes,
      selectedNotification
    });
  };

  clientConnect = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({
      notificationCallModal: true,
      selectedNumber: selectedNotification.mobile || '',
      selectedClassId: selectedNotification.classId || '',
      selectedSalesId: selectedNotification.notificationId || '',
      selectedRecipientName: selectedNotification.name || '',
      messageChannel: 'sms',
      whatsappHistory: [],
      showWhatsappHistory: false,
    });
  };

  fetchWhatsappHistory = () => {
    const { selectedNumber } = this.state;
    if (!selectedNumber) return;
    this.setState({ loadingWhatsappHistory: true });
    const fullNumber = selectedNumber.startsWith('+') ? selectedNumber : `+1${selectedNumber}`;
    axiosGet(`message/whatsapp/history/${fullNumber}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            whatsappHistory: response.data || [],
            loadingWhatsappHistory: false,
            showWhatsappHistory: true
          });
        } else {
          this.setState({ loadingWhatsappHistory: false });
          alert('Failed to load WhatsApp history.');
        }
      })
      .catch((error) => {
        this.setState({ loadingWhatsappHistory: false });
        console.error('Error fetching WhatsApp history:', error);
        alert('Error loading WhatsApp history.');
      });
  };

  startClass = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({ startClass: true, selectedNotification }, () => {
      this.callStartEvent(selectedNotification);
    });
  };

  callStartEvent = () => {
    let { selectedNotification, startClass } = this.state;
    let dataToSend = {
      notificationId: selectedNotification.notificationId,
      startClass
    }
    axiosPost(`sales/start-class-update`, dataToSend)
      .then((response) => {
        if (!response.isError) {
          const notification = this.state.allMessages.find((item) => item.notificationId === selectedNotification.notificationId);
          notification.startClass = true;
          this.setState(
            {
              successModal: true,
              modalTitle: 'Success',
              message: 'Class started successfully After 40 min it will be automatically End Class',
            }
          );
        } else {
          this.setState(
            {
              errorModal: true,
              modalTitle: 'Sorry!',
              message: response.message,
            }
          );
        }
      })
      .catch((errorResponse) => {
        this.setState(
          {
            errorModal: true,
            loading: false,
            modalTitle: 'Sorry!',
            message: errorResponse.message,
          },
          () => {
            this.resetForm();
          }
        );
      });
  };



  callCancelEvent = async (notiInfo) => {
    const regex = /\/scheduled_events\/(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})/;
    let eventId = notiInfo.calendlyID.match(regex);
    if (eventId && eventId[1]) {
      eventId = eventId[1];
      // Calendly personal-access tokens, per-classId. Math (CLASS1695200316932) and Speak Club
      // (CLASS1784904166957) have never had a Calendly account/token here — pre-existing gap,
      // not new to Speak Club. Both classes now book trials through NeetoCal instead of
      // Calendly (see neetoWebhook), so a missing token below should skip this call rather
      // than send `Bearer undefined` to Calendly's API.
      const token = {
        "CLASS1648760926141": "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjg2Mjg5MjY1LCJqdGkiOiI5YWQzZDk5Yy03NTBhLTRkOGUtYjczZC03Y2ZkOTIxZjRlZjgiLCJ1c2VyX3V1aWQiOiJiODYyZGVjMS1kYjBmLTQ3ODItYmI2MS04OGVkMjI2MjEwZGIifQ.McPqQ9cgj0XN8zRYpUysrOTHK0W4Nv6vLY1zuthiFV1k-mRMJT0r4gF1OydYhDabnOWQf7ld0BXFcxTd0KUFAg",
        "CLASS1682531326773": "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjg5MDU2NDAxLCJqdGkiOiIyMWFmYWYxMC0xYjgzLTRjOWItYjFmYi1jZjM1MWEyMWQxOTIiLCJ1c2VyX3V1aWQiOiIzOGRiYzRlZi1iMGNiLTQxNjctYTBmYy0yNmNjNWU0ZTkyZTcifQ.5rwz9VFPiQE63uIimsORMJ0Qzpy-vag8Cvh0Zoe05zvs4l-XqMDEcuyNaN_5_bfyFmgJQcjI1DJAbzKIYADLKw",
        "CLASS1688966054748": "eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjg5MDU2NDAxLCJqdGkiOiIyMWFmYWYxMC0xYjgzLTRjOWItYjFmYi1jZjM1MWEyMWQxOTIiLCJ1c2VyX3V1aWQiOiIzOGRiYzRlZi1iMGNiLTQxNjctYTBmYy0yNmNjNWU0ZTkyZTcifQ.5rwz9VFPiQE63uIimsORMJ0Qzpy-vag8Cvh0Zoe05zvs4l-XqMDEcuyNaN_5_bfyFmgJQcjI1DJAbzKIYADLKw"
      }
      const classToken = token[notiInfo.classId];
      if (!classToken) {
        return this.setState({
          loading: false,
          errorModal: true,
          modalTitle: 'Sorry!',
          message: 'This class is not connected to Calendly, so it could not be auto-cancelled there. Please cancel it manually if it was booked via Calendly.',
        });
      }
      const data = await Axios.post(`https://api.calendly.com/scheduled_events/${eventId}/cancellation`, {
        reason: "Admin cancelled the event",
      }, { headers: { Accept: 'application/json', Authorization: `Bearer ${classToken}` } });
      if (data.status === 204) {
        return this.setState({
          loading: false,
          successModal: true,
          modalTitle: 'Success',
          message: 'Event cancelled successfully',
        })
      }
      return this.setState({
        loading: false,
        errorModal: true,
        modalTitle: 'Sorry!',
        message: 'Event cancellation failed',
      })
    }
  }

  handleNotificationStatusChange = (e, index) => {
    let message = "Are you sure you want to change the status?"
    if (e.label === "Cancel Class") {
      message = "Are you sure you want to cancel the class? This will cancel session"
    }
    let confirm = window.confirm(message);
    if (confirm) {
      let { notificationId, allMessages } = this.state;
      let selectedNotification = allMessages[index];
      let dataToSend = {
        notificationId: selectedNotification.notificationId,
        notificationStatus: e.value
      };
      this.setState({ loading: true });
      axiosPost('sales/update-notification-status', dataToSend)
        .then((response) => {
          if (!response.isError) {
            if (e.label === "Cancel Class") {
              this.callCancelEvent(selectedNotification)
            }
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully Updated.',
              },
              () => {
                this.getSalesNotification();
              }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
    }
  };

  sendReminder = (notificationId, classId) => {
    let confirm = window.confirm("Are you sure you want to Send Reminder?");
    if (confirm) {
      axiosPost('sales/send-reminder', { notificationId, classId })
        .then((response) => {
          if (!response.isError) {
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully Updated.',
              },
              () => {
                this.getSalesNotification();
              }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
    }

  }

  callInit = (sale, index) => {
    axiosPost('sales/token', {})
      .then((response) => {
        if (!response.isError) {
          this.setState(
            {
              loading: false
            },
            () => {
              const token = response.data.token;
              const device = new Device(token, {
                logLevel: 1,
                codecPreferences: ["opus", "pcmu"],
              });
              device.register();
              this.setState({ device })
              // setDevice(device);
              device.addListener("connect", (device) => {
                console.log("Connect event listener added .....");
                return device;
              });
              device.on("registered", () => {
                console.log("Agent registered");
                this.setState({ userState: USER_STATE.READY });
              });
              device.on("connect", (connection) => {
                console.log("Call connect");
                this.setState({ userState: USER_STATE.ON_CALL })
              });
              device.on("disconnect", () => {
                console.log("Disconnect event");
                this.setState({ userState: USER_STATE.READY })
              });
              setTimeout(() => {
                this.handleCall(sale, index)
              }, 1000)

              return () => {
                device.destroy();
                this.setState({ device: undefined })
                this.setState({ userState: USER_STATE.OFFLINE })
              };
            }
          );
        } else {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorModal: true,
          modalTitle: 'Sorry!',
          message: 'Something is wrong. Try again later.',
        });
        console.log(error);
      });
  }

  stopReminder = (notificationId) => {
    let confirm = window.confirm("Are you sure you want to Stop Reminder?");
    if (confirm) {
      axiosPost('sales/stop-reminder', { notificationId })
        .then((response) => {
          if (!response.isError) {
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully Updated.',
              },
              () => {
                this.getSalesNotification();
              }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
    }

  }

  deleteNotification = (index) => {
    let confirm = window.confirm("Are you sure you want to Delete?");
    if (confirm) {
      let { allMessages } = this.state;
      let selectedNotification = allMessages[index];
      this.setState({ loading: true });
      // API -
      axiosPost('sales/delete-notification', { notificationId: selectedNotification.notificationId })
        .then((response) => {
          if (!response.isError) {
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully deleted',
              },
              () => {
                this.getSalesNotification();
              }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
    }
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  updateNotificationMessage = (e) => {
    let { message10min,
      message24hr,
      message72hr, messageBefore24hr, messageBefore10min, subject10min, subject24hr,
      subject72hr,
      subjectBefore24hr,
      subjectBefore10min, messageId, pdfLinkMessage10min, pdfLinkMessageBefore10min,
      pdfLinkMessageBefore24hr,
      pdfLinkMessage24hr,
      pdfLinkMessage72hr, classId } = this.state;
    if (!message10min && !message24hr &&
      !message72hr && !messageBefore24hr && !subject10min && !messageBefore10min && !subject24hr &&
      !subject72hr && !subjectBefore24hr && !subjectBefore10min && !messageId && !classId) {
      return alert('Please enter all the fields');
    }
    this.setState({ loading: true });
    let dataToSend = {
      messageId,
      classId,
      message10min,
      message24hr,
      subject10min,
      subject24hr,
      subject72hr,
      subjectBefore24hr,
      subjectBefore10min,
      message72hr,
      messageBefore10min,
      messageBefore24hr,
      pdfLinkMessage10min,
      pdfLinkMessageBefore10min,
      pdfLinkMessageBefore24hr,
      pdfLinkMessage24hr,
      pdfLinkMessage72hr,

    }
    axiosPost('sales/update-notification-message', dataToSend)
      .then((response) => {
        if (!response.isError) {
          this.setState(
            {
              loading: false,
              successModal: true,
              modalTitle: 'Success',
              message: 'Successfully Updated.',
            },
            () => {
              this.getSalesNotification();
            }
          );
        } else {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorModal: true,
          modalTitle: 'Sorry!',
          message: 'Something is wrong. Try again later.',
        });
      });

  }

  searchNotification = (e) => {
    let val = e.target.value;
    this.setState({ searchNotification: val }, () => {
      this.debouncedSearch(val);
    });
  };


  getHeaders = () => {
    return [
      { label: "User Name", key: "userName" },
      { label: "Class Name", key: "className" },
      { label: "Email", key: "email" },
      { label: "Mobile Number", key: "mobileNumber" },
      { label: "Start Time", key: "startTime" },
      { label: "Time Zone", key: "timeZone" },
      { label: "Created By", key: "CreatedBy" },
      { label: "Status", key: "status" },
      { label: "Notes", key: "notes" },
    ];
  };

  getCSVData = () => {
    const { allMessageCsvData, classList } = this.state;
    return buildSalesNotificationCSVRows(allMessageCsvData, classList);
  };


  changeSales = (value) => {
    const { allSalesUser } = this.state;
    const saleUser = allSalesUser.find((_data) => {
      return _data.name === value
    })
    this.setState({ createdBy: value, zoomLinkSales: saleUser.zoomLink || '' });
  }

  updateMessageState = (index, newState) => {
    this.setState(prevState => ({
      messageStates: {
        ...prevState.messageStates,
        [index]: newState
      }
    }));
  };

  handleCall = async (sale, index) => {
    const confirm = window.confirm('Are you sure want to call?')
    if (!confirm) {
      return false;
    }
    const { device, userType } = this.state;
    device.emit("connect");
    const mobileToCall = sale.mobile && !sale.mobile.startsWith('+') ? `+1${sale.mobile}` : sale.mobile;
    device.connect({ params: { To: mobileToCall, notificationId: sale.notificationId, userType, classId: sale.classId } }).then((call) => {
      call.on("accept", () => {
        this.updateMessageState(index, USER_STATE.ON_CALL);
        console.log("call accepted");
      });
      call.on("disconnect", () => {
        console.log("The call has been disconnected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
      call.on("reject", () => {
        console.log("The call was rejected.");
      });
      call.on("cancel", () => {
        console.log("The call was rejected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
    })
  };

  rejectCall = () => {
    const { device, selectedNumber } = this.state
    device.emit("disconnect");
    device.emit("cancel");
    device.emit("reject");
    device.disconnectAll({ params: { To: selectedNumber } });
  }


  replyMessageResponse = () => {
    let { twillioMessage, loading, selectedNumber, selectedClassId } = this.state;
    if (!twillioMessage || twillioMessage.trim() === '') {
      return alert('Please enter message');
    }

    let confirm = window.confirm('Are you sure want send message?');

    if (confirm) {
      if (twillioMessage && !loading) {
        this.setState({ loading: true });
        const fullNumber = selectedNumber.startsWith('+') ? selectedNumber : `+1${selectedNumber}`;
        let dataToSend = {
          message: twillioMessage,
          to: fullNumber,
          classId: selectedClassId
        };

        const endpoint = 'message/send-reply';
        // API -
        axiosPost(endpoint, dataToSend)
          .then((response) => {
            if (!response.isError) {
              this.setState(
                {
                  loading: false,
                  notificationCallModal: false,
                  twillioMessage: '',
                  selectedNumber: '',
                },
                () => {
                }
              );
            } else {
              this.setState({
                loading: false,
                modalTitle: 'Sorry!',
                message: 'Something is wrong. Try again later.',
                notificationCallModal: false,
                twillioMessage: '',
                selectedNumber: '',
              });
            }
          })
          .catch((error) => {
            this.setState({
              loading: false,
              errorModal: true,
              message: 'Something is wrong. Try again later.',
              notificationCallModal: false,
              twillioMessage: '',
              selectedNumber: '',
            });
          });
      }
    }
  };

  isTimeInRange(timezone) {
    const now = new Date();
    const userTime = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: timezone }).format(now);
    const hour = parseInt(userTime, 10);

    // Check if the time is between 8 AM (8) and 9 PM (21)
    return hour >= 8 && hour < 21;
  }

  dataFromListOfUsersState = () => {
    return this.state.allMessageCsvData;
  }

  render() {
    const csvReport = {
      data: this.getCSVData(),
      headers: this.getHeaders(),
      filename: `${moment().format("YYYY-MM-DD")}-Sales-Data.csv`,
    };

    const onChangeHandler = (event) => {
      this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      });
    };

    const fileChange = (e, key, pdfRefs) => {
      let file = pdfRefs.current && pdfRefs.current.files && pdfRefs.current.files[0];
      let blnValid = false;
      if (file) {
        let sFileName = file.name;
        var _validFileExtensions = ['.pdf'];
        for (var j = 0; j < _validFileExtensions.length; j++) {
          var sCurExtension = _validFileExtensions[j];
          if (
            sFileName
              .substr(
                sFileName.length - sCurExtension.length,
                sCurExtension.length
              )
              .toLowerCase() === sCurExtension.toLowerCase()
          ) {
            blnValid = true;
            break;
          }
        }

        if (blnValid) {
          this.setState({ uploading: true });
          const data = new FormData();
          data.append('file', file);

          axiosPost(`utility/upload-file`, data, true)
            .then((response) => {
              if (!response.isError) {
                // this.setState((prevState) => {
                //   const links = type === 'homework' ? prevState.homeWorkLink : prevState.classWorkLink;
                //   links[index][name] = response.data?.fileUrl;
                //   return { links };
                // })

                this.setState({
                  [key]: response.data?.fileUrl,
                  uploading: false,
                  successModal: true,
                  message: 'Successfully uploaded',
                  modalTitle: 'Success',
                });
              } else {
                this.setState({
                  uploading: false,
                  errorModal: false,
                  message: "Sorry! can't be uploaded.",
                  modalTitle: 'Sorry!',
                });
              }
            })
            .catch((error) => {
              this.setState({
                uploading: false,
                errorModal: false,
                message: "Sorry! can't be uploaded.",
                modalTitle: 'Sorry!',
              });
            });
        } else {
          this.setState({
            errorModal: true,
            message: 'File format is not supported',
            modalTitle: 'Sorry',
          });
        }
      } else {
        this.setState({
          errorModal: true,
          message: 'File size is exceeded',
          modalTitle: 'Sorry',
        });
      }
    };



    let {
      loading,
      allMessages,
      listPage,
      listPageSale,
      totalNewPage,
      totalNewPageSale,
      notificationModal,
      notificationCallModal,
      editModal,
      editSalesModal,
      notificationNotesModal,
      notes,
      modalTitle,
      nameError,
      notesError,
      emailError,
      mobileError,
      classIdError,
      createdByError,
      email,
      name,
      mobile,
      uploading,
      message,
      successModal,
      errorModal,
      filterTeacher,
      allNotificationStatus,
      activeTab,
      message10min,
      subject10min,
      subject24hr,
      subject72hr,
      subjectBefore24hr,
      subjectBefore10min,
      message24hr,
      message72hr,
      messageBefore24hr,
      messageBefore10min,
      pdfLinkMessage10min,
      pdfLinkMessageBefore10min,
      pdfLinkMessageBefore24hr,
      pdfLinkMessage24hr,
      pdfLinkMessage72hr,
      allSalesUser,
      userType,
      allCounts,
      duplicatesNotification,
      zoomLink,
      classList,
      classId,
      createdBy,
      zoomLinkSales,
      userState,
      twillioMessage,
      teachersList,
      teacherId,
      allMessageCsvData,
      messageChannel,
      whatsappHistory,
      loadingWhatsappHistory,
      showWhatsappHistory
    } = this.state;
    return (
      <>
        <Header key={'index'} isFromDashboard={(userType == 'admin' || userType == 'sub_admin' || userType == 'sales_ops') ? true : false} allCounts={allCounts} />
        {/* Page content */}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' }, styles.navLink)}
              onClick={() => {
                this.toggle("1");
              }}>
              Notifications
            </NavLink>
          </NavItem>
          {(userType === 'admin' || userType === 'sub_admin') && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' }, styles.navLink)}
                onClick={() => {
                  this.toggle("2");
                }}
              >
                Messages
              </NavLink>
            </NavItem>
          )}

          {(userType === 'admin' || userType === 'sub_admin') && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '3' }, styles.navLink)}
                onClick={() => {
                  this.toggle("3");
                }}
              >
                Sales Users
              </NavLink>
            </NavItem>
          )}
          {(userType === 'admin' || userType === 'sub_admin') && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '4' }, styles.navLink)}
                onClick={() => {
                  this.toggle("4");
                }}
              >
                Duplicates Notifications
              </NavLink>
            </NavItem>
          )}


        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Container fluid>
              {/* Table */}
              <Row>
                <div className='col'>
                  <Card className='shadow'>
                    <CardHeader className="bg-transparent border-0 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center py-4" style={{ gap: '15px' }}>
                      <h3 className="mb-0 text-primary font-weight-700" style={{ fontSize: '20px' }}>All Messages</h3>
                    </CardHeader>

                    <CardBody className="pt-0 border-0 pb-4">
                      <Row className="align-items-end" style={{ rowGap: '15px' }}>
                        <Col xs="12" sm="6" md="4" lg="3">
                          <FormGroup className="mb-0">
                            <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>SEARCH</label>
                            <div className="d-flex align-items-center" style={{ backgroundColor: '#fff', border: '1px solid #e9ecef', borderRadius: '8px', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                              <i className="fa fa-search text-muted mr-2" style={{ fontSize: '13px' }} />
                              <input
                                placeholder="Search by Name, Email or Mobile Number"
                                type="text"
                                name="search"
                                className="w-100"
                                style={{ backgroundColor: 'transparent', border: 'none', color: '#525f7f', fontSize: '14px', outline: 'none' }}
                                onChange={this.searchNotification}
                              />
                            </div>
                          </FormGroup>
                        </Col>

                        <Col xs="12" sm="6" md="4" lg="2">
                          <FormGroup className="mb-0">
                            <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>STATUS TYPE</label>
                            <Select
                              placeholder="Select Status"
                              defaultValue={{ value: 'upcoming', label: 'Upcoming' }}
                              options={[
                                { value: 'upcoming', label: 'Upcoming' },
                                { value: 'completed', label: 'Completed' }
                              ]}
                              styles={selectCustomStyles}
                              onChange={(e) => { this.setState({ filterNotificationStatus: e.value, page: 1 }, () => { this.getSalesNotification() }) }}
                            />
                          </FormGroup>
                        </Col>

                        {(userType === 'admin' || userType === 'sub_admin') && (
                          <>
                            <Col xs="12" sm="6" md="4" lg="2">
                              <FormGroup className="mb-0">
                                <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>SALES USER</label>
                                <Select
                                  placeholder="Select Sales"
                                  options={[
                                    { value: '', label: 'All' },
                                    ...(allSalesUser &&
                                      allSalesUser.map((item) => ({
                                        value: item.name,
                                        label: item.name,
                                      }))),
                                  ]}
                                  styles={selectCustomStyles}
                                  onChange={(e) => { this.setState({ filterSaleUser: e.value, page: 1 }, () => { this.getSalesNotification() }) }}
                                />
                              </FormGroup>
                            </Col>

                            <Col xs="12" sm="6" md="4" lg="2">
                              <FormGroup className="mb-0">
                                <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>DATE FROM</label>
                                <div className="d-flex align-items-center" style={{ backgroundColor: '#fff', border: '1px solid #e9ecef', borderRadius: '8px', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                                  <i className="fa fa-calendar-alt text-muted mr-2" style={{ fontSize: '13px' }} />
                                  <input
                                    type="date"
                                    className="w-100"
                                    style={{ backgroundColor: 'transparent', border: 'none', color: '#525f7f', fontSize: '14px', outline: 'none' }}
                                    onChange={(e) =>
                                      this.setState(
                                        {
                                          filterFromDate: e.target.value,
                                          page: 1,
                                        },
                                        () => {
                                          this.getSalesNotification();
                                        }
                                      )
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Col xs="12" sm="6" md="4" lg="2">
                              <FormGroup className="mb-0">
                                <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>DATE TO</label>
                                <div className="d-flex align-items-center" style={{ backgroundColor: '#fff', border: '1px solid #e9ecef', borderRadius: '8px', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                                  <i className="fa fa-calendar-alt text-muted mr-2" style={{ fontSize: '13px' }} />
                                  <input
                                    type="date"
                                    className="w-100"
                                    style={{ backgroundColor: 'transparent', border: 'none', color: '#525f7f', fontSize: '14px', outline: 'none' }}
                                    onChange={(e) =>
                                      this.setState(
                                        {
                                          filterToDate: e.target.value,
                                          page: 1,
                                        },
                                        () => {
                                          this.getSalesNotification();
                                        }
                                      )
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </Col>

                            <Col xs="12" sm="6" md="4" lg="3">
                              <FormGroup className="mb-0">
                                <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>NOTIFICATION STATUS</label>
                                <Select
                                  options={allNotificationStatus}
                                  placeholder="Notification Status"
                                  isSearchable={true}
                                  styles={selectCustomStyles}
                                  onChange={(e) =>
                                    this.setState(
                                      {
                                        notificationStatus: e ? e.value : '',
                                        page: 1,
                                      },
                                      () => {
                                        this.getSalesNotification();
                                      }
                                    )
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </>
                        )}
                      </Row>

                      {/* Action buttons list in a beautifully wrapped row */}
                      {(userType === 'admin' || userType === 'sub_admin') && (
                        <div className="d-flex flex-wrap align-items-center mt-3 pt-2" style={{ gap: '12px' }}>
                          <Button
                            color="primary"
                            type="button"
                            className="shadow-sm font-weight-600 px-3 py-2"
                            style={{ borderRadius: '8px', fontSize: '13px' }}
                            onClick={() => this.getSalesNotificationCSV()}
                          >
                            <i className="fa fa-download mr-1.5" /> Export to CSV
                          </Button>
                          <Button
                            color="success"
                            type="button"
                            className="shadow-sm font-weight-600 px-3 py-2"
                            style={{ borderRadius: '8px', fontSize: '13px' }}
                            onClick={() => this.setState({ addTrialModal: true })}
                          >
                            <i className="fa fa-plus mr-1.5" /> Add Trial
                          </Button>
                          <CSVLink id={'csvData'} style={{ display: "none" }} {...csvReport}>
                            Export to CSV
                          </CSVLink>

                          <a
                            className="btn btn-info shadow-sm font-weight-600 px-3 py-2 text-white"
                            style={{ borderRadius: '8px', fontSize: '13px' }}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            href={'https://calendly.com/d/224-z46-sf2/free-1-1-python-class'}
                          >
                            <i className="fa fa-calendar-plus mr-1.5" /> Book Python Class
                          </a>

                          <a
                            className="btn btn-info shadow-sm font-weight-600 px-3 py-2 text-white"
                            style={{ borderRadius: '8px', fontSize: '13px' }}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            href={'https://calendly.com/d/yxq-wyn-wnr/free-1-1-chess-class'}
                          >
                            <i className="fa fa-calendar-plus mr-1.5" /> Book Chess Class
                          </a>
                        </div>
                      )}
                    </CardBody>



                    <Table
                      className='align-items-center table-flush cp; d-none d-lg-table'
                      responsive
                      style={{ marginBottom: '100px' }}
                    >
                      <thead className='thead-light'>
                        <tr>
                          {
                            (userType === 'admin' || userType === 'sub_admin') && (
                              <th scope='col' style={{ width: '140px' }}>Actions</th>
                            )
                          }

                          <th scope='col'>Student Details</th>
                          <th scope='col'>Class name</th>
                          <th scope='col'>Start Time</th>
                          <th scope='col'>Time Zone</th>
                          <th scope='col'>Created By</th>
                          <th scope='col'>Age</th>
                          <th scope='col'>Before Class</th>
                          <th scope='col'>After Class</th>

                          <th scope='col'>Status</th>

                          <th scope='col'>Reminder</th>
                          <th scope='col'>Notes</th>
                          <th scope='col'>Class Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allMessages &&
                          allMessages.map((value, index) => {
                            const isActiveTime = this.isTimeInRange(value?.timezone || 'Asia/kolkata');
                            const [isRegistration] = value?.sections && value?.sections.map((section) => {
                              if (section.classId == value.classId) {
                                return true
                              }
                            })
                            const isActive = Object.values(this.state.messageStates).some(
                              state => state === 'Connecting' || state === 'On call'
                            )
                            const userStateForMessage = this.state.messageStates[index] || USER_STATE.OFFLINE;
                            const className = classList?.find((item) => item?.classId === value?.classId)?.name;

                            let rowStyle = {};
                            let firstCellStyle = {};
                            if (value.notificationStatus === 'Cancel Class') {
                              rowStyle = { backgroundColor: '#fff5f6' };
                              firstCellStyle = { borderLeft: '5px solid #f5365c' };
                            } else if (value?.startClass) {
                              rowStyle = { backgroundColor: '#f0fbfd' };
                              firstCellStyle = { borderLeft: '5px solid #2dce89' };
                            }

                            return (
                              value.isActive && (
                                <tr key={index} style={rowStyle}>
                                  {
                                    (userType === 'admin' || userType === 'sub_admin') && (
                                      <td className={'table-column-width'} style={{ ...firstCellStyle, verticalAlign: 'middle', width: '140px' }} >
                                        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                          <UncontrolledDropdown>
                                            <DropdownToggle
                                              className='btn-icon-only text-light'
                                              href='JavaScript:Void(0);'
                                              role='button'
                                              size='sm'
                                              color=''
                                              onClick={(e) => e.preventDefault()}
                                            >
                                              <i className='fas fa-ellipsis-v' />
                                            </DropdownToggle>
                                            <DropdownMenu
                                              className='dropdown-menu-arrow'
                                              right
                                            >
                                              <DropdownItem
                                                href='JavaScript:Void(0);'
                                                onClick={() => this.editNotification(index)}
                                              >
                                                Edit
                                              </DropdownItem>
                                              <DropdownItem
                                                href='JavaScript:Void(0);'
                                                onClick={() => this.deleteNotification(index)}
                                              >
                                                Delete
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>

                                          {
                                            (userStateForMessage === 'Connecting' || userStateForMessage === 'On call') ? (
                                              <Button
                                                color="danger"
                                                size="sm"
                                                className="btn-icon-only rounded-circle"
                                                onClick={() => this.rejectCall(value.mobile)}
                                                title="Hang up call"
                                              >
                                                <i className="fa fa-phone" style={{ fontSize: '13px' }} />
                                              </Button>
                                            ) : (
                                              <Button
                                                color="secondary"
                                                size="sm"
                                                className="btn-icon-only rounded-circle shadow-sm"
                                                disabled={isActive}
                                                onClick={() => this.callInit(value, index)}
                                                title="Voice call"
                                                style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                              >
                                                <i className="fa fa-phone text-success" style={{ fontSize: '13px' }} />
                                              </Button>
                                            )
                                          }
                                          <Button
                                            color="secondary"
                                            size="sm"
                                            className="btn-icon-only rounded-circle shadow-sm"
                                            onClick={() => this.clientConnect(index)}
                                            title="Chat comments"
                                            style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                          >
                                            <i className="fa fa-comments text-primary" style={{ fontSize: '13px' }} />
                                          </Button>
                                          <Button
                                            color="secondary"
                                            size="sm"
                                            className="btn-icon-only rounded-circle shadow-sm"
                                            onClick={() => this.openDirectWhatsapp(value)}
                                            title="Send Direct WhatsApp"
                                            style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                          >
                                            <i className="fab fa-whatsapp text-success" style={{ fontSize: '14px', fontWeight: 'bold' }} />
                                          </Button>
                                        </div>
                                      </td>
                                    )
                                  }

                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                    <div className="d-flex flex-column" style={{ gap: '2px' }}>
                                      <div className="d-flex align-items-center">
                                        {isRegistration && (
                                          <span style={{ backgroundColor: '#11cdef', borderRadius: '50%', display: 'inline-block', height: '8px', marginRight: '6px', width: '8px' }} />
                                        )}
                                        {value?.isSendBeforeMail && (
                                          <span style={{ backgroundColor: 'green', borderRadius: '50%', display: 'inline-block', height: '8px', marginRight: '6px', width: '8px' }} />
                                        )}
                                        <span className="font-weight-700 text-dark" style={{ fontSize: '13.5px' }}>{value.name}</span>
                                      </div>
                                      <a href={`mailto:${value.email}`} className="text-muted" style={{ fontSize: '11.5px', textDecoration: 'none' }}>
                                        <i className="fa fa-envelope mr-1 text-muted" style={{ fontSize: '10px' }} />
                                        {value.email}
                                      </a>
                                      {value.mobile && (
                                        <a href={"tel:" + value.mobile} className="text-muted font-weight-600" style={{ fontSize: '11.5px', textDecoration: 'none' }}>
                                          <i className="fa fa-phone mr-1 text-muted" style={{ fontSize: '10px' }} />
                                          {value.mobile}
                                        </a>
                                      )}
                                      {value.grade && (
                                        <span className="text-muted font-weight-600" style={{ fontSize: '11.5px' }}>
                                          <i className="fa fa-graduation-cap mr-1 text-muted" style={{ fontSize: '10px' }} />
                                          {value.grade}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>{className || ''}</td>

                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                    <span className="font-weight-600 text-muted" style={{ fontSize: '12.5px' }}>
                                      {value.startTime
                                        ? moment(value.startTime).format('ll hh:mm A')
                                        : ''}
                                    </span>
                                  </td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>{value?.timezone || ''}</td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                    <Badge color="secondary" className="font-weight-700 text-uppercase" style={{ fontSize: '10.5px' }}>
                                      {value?.createdBy || 'SYSTEM'}
                                    </Badge>
                                  </td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>{value?.age || ''}</td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                    <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                      <Badge color={value.isDeliveredBefore10Min ? 'success' : 'info'} className="px-2 py-1" style={{ borderRadius: '6px', fontSize: '10px' }}>
                                        1hr: {value.isDeliveredBefore10Min ? 'Delivered' : 'Pending'}
                                      </Badge>
                                      <Badge color={value.isDeliveredBefore24hr ? 'success' : 'info'} className="px-2 py-1" style={{ borderRadius: '6px', fontSize: '10px' }}>
                                        24hr: {value.isDeliveredBefore24hr ? 'Delivered' : 'Pending'}
                                      </Badge>
                                    </div>
                                  </td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                    <div className="d-flex flex-column" style={{ gap: '4px' }}>
                                      <Badge color={value.isDelivered10Min ? 'success' : 'info'} className="px-2 py-1" style={{ borderRadius: '6px', fontSize: '10px' }}>
                                        1M: {value.isDelivered10Min ? 'Delivered' : 'Pending'}
                                      </Badge>
                                      <Badge color={value.isDelivered24hr ? 'success' : 'info'} className="px-2 py-1" style={{ borderRadius: '6px', fontSize: '10px' }}>
                                        24h: {value.isDelivered24hr ? 'Delivered' : 'Pending'}
                                      </Badge>
                                      <Badge color={value.isDelivered72hr ? 'success' : 'info'} className="px-2 py-1" style={{ borderRadius: '6px', fontSize: '10px' }}>
                                        72h: {value.isDelivered72hr ? 'Delivered' : 'Pending'}
                                      </Badge>
                                    </div>
                                  </td>
                                  <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                    <div>
                                      <Select
                                        options={allNotificationStatus}
                                        placeholder="Select Notification Status"
                                        isSearchable={true}
                                        menuPosition={'fixed'}
                                        menuPlacement={'bottom'}
                                        styles={{
                                          control: styles => ({ ...styles, borderRadius: '8px', width: 200 }),
                                          menu: styles => ({ ...styles, borderRadius: '8px', width: 200 }),
                                        }}
                                        onChange={(e) => this.handleNotificationStatusChange(e, index)}
                                        value={allNotificationStatus.find(option => option.value == value.notificationStatus)}
                                      />
                                    </div>
                                  </td>

                                  {
                                    value.notificationStatus == 'Default' ? (
                                      <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                        <Button color="primary" size="sm" style={{ borderRadius: '8px', fontWeight: '700' }} onClick={() => this.sendReminder(value.notificationId, value.classId)}>Send Reminder</Button>
                                      </td>
                                    ) : (
                                      <td style={{ verticalAlign: 'middle', width: '120px' }}>
                                        {value.sendNotification ?
                                          <Button color="danger" size="sm" style={{ borderRadius: '8px', fontWeight: '700' }} onClick={() => this.stopReminder(value.notificationId)}>Stop Reminder</Button>
                                          :
                                          <Button color="warning" size="sm" disabled style={{ borderRadius: '8px', fontWeight: '700' }}>Stopped</Button>
                                        }
                                      </td>
                                    )
                                  }
                                  <td style={{ verticalAlign: 'middle', maxWidth: '200px' }}>
                                    <div>
                                      <Button color="default" size="sm" style={{ borderRadius: '8px', fontWeight: '700' }} onClick={() => this.addNotes(index)}>Add Notes</Button>
                                      {value.notes && (
                                        <div style={{ marginTop: '6px', fontSize: '11px', color: '#525f7f', backgroundColor: '#f6f9fc', border: '1px solid #e9ecef', borderRadius: '6px', padding: '5px 8px', maxHeight: '60px', overflowY: 'auto', wordBreak: 'break-word' }}>
                                          {value.notes}
                                        </div>
                                      )}
                                    </div>
                                  </td>

                                  <td style={{ verticalAlign: 'middle' }}>
                                    <div>
                                      <Button color="primary" size="sm" style={{ borderRadius: '8px', fontWeight: '700' }} onClick={() => this.startClass(index)}>Start Session</Button>
                                      {value.started_at && value.started_at.length > 0 ? (
                                        <div className="mt-2" style={{ width: '100%' }}>
                                          <span className="badge badge-dot mr-4">
                                            <i className="bg-success" style={{ height: '8px', width: '8px' }} />
                                            <span className="status font-weight-700 text-success" style={{ fontSize: '11px' }}>
                                              Started ({value.started_at.length}x)
                                            </span>
                                          </span>
                                          <div
                                            className="shadow-sm mt-1"
                                            style={{
                                              backgroundColor: '#fbfcfd',
                                              border: '1px solid rgba(0,0,0,.05)',
                                              borderRadius: '6px',
                                              maxHeight: '110px',
                                              overflowY: 'auto',
                                              padding: '8px 10px',
                                            }}
                                          >
                                            {value.started_at.map((start, i) => (
                                              <div
                                                key={i}
                                                className="d-flex align-items-center mb-1 pb-1"
                                                style={{
                                                  borderBottom: i < value.started_at.length - 1 ? '1px dashed #e9ecef' : 'none',
                                                  fontSize: '11px',
                                                }}
                                              >
                                                <i className="fa fa-user text-muted mr-1" style={{ fontSize: '10px' }} />
                                                <strong className="text-primary mr-1" style={{ fontSize: '10.5px' }}>
                                                  {start.teacherId || 'Teacher'}
                                                </strong>
                                                <span className="text-muted ml-auto">
                                                  {moment(start.startedAt).format('h:mm A')}
                                                </span>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      ) : (
                                        value.startClassTime && (
                                          <div className="mt-2">
                                            <span className="badge badge-dot mr-4">
                                              <i className="bg-success" style={{ height: '8px', width: '8px' }} />
                                              <span className="status text-success font-weight-600" style={{ fontSize: '11px' }}>
                                                Started: {moment(value.startClassTime).format('hh:mm A')}
                                              </span>
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </td>


                                </tr>
                              )
                            );
                          })}
                      </tbody>
                    </Table>

                    {/* Mobile/Tablet Card-List View */}
                    <div className="d-block d-lg-none px-3 py-3" style={{ backgroundColor: '#f8f9fe' }}>
                      {allMessages && allMessages.length > 0 ? (
                        allMessages.map((value, index) => {
                          if (!value.isActive) return null;

                          const isActiveTime = this.isTimeInRange(value?.timezone || 'Asia/kolkata');
                          const startClass = value?.startClass ? { color: 'green' } : value.notificationStatus == 'Cancel Class' ? { color: 'red' } : { color: '' };
                          const [isRegistration] = value?.sections && value?.sections.map((section) => {
                            if (section.classId == value.classId) {
                              return true
                            }
                          })
                          const isActive = Object.values(this.state.messageStates).some(
                            state => state === 'Connecting' || state === 'On call'
                          )
                          const userStateForMessage = this.state.messageStates[index] || USER_STATE.OFFLINE;
                          const className = classList?.find((item) => item?.classId === value?.classId)?.name;

                          let borderLeftStyle = '1px solid #e9ecef';
                          let cardBgStyle = {};
                          if (value.notificationStatus === 'Cancel Class') {
                            cardBgStyle = { backgroundColor: '#fff5f6' };
                            borderLeftStyle = '6px solid #f5365c';
                          } else if (value?.startClass) {
                            cardBgStyle = { backgroundColor: '#f0fbfd' };
                            borderLeftStyle = '6px solid #2dce89';
                          }

                          return (
                            <Card key={index} className="mb-4 border-0" style={{ ...cardBgStyle, borderLeft: borderLeftStyle, borderRadius: '16px', boxShadow: '0 8px 24px rgba(50,50,93,.05),0 1px 3px rgba(0,0,0,.03)', overflow: 'hidden' }}>
                              <CardBody className="p-3">
                                {/* Header: Student Profile & Action Toggle */}
                                <div className="d-flex justify-content-between mb-3">
                                  <div style={{ maxWidth: '80%' }}>
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Student Profile</span>
                                    <h4 className="font-weight-700 text-dark mb-1 d-inline-flex align-items-center mt-1" style={{ fontSize: '15px' }}>
                                      {isRegistration && (
                                        <span style={{ backgroundColor: '#11cdef', borderRadius: '50%', display: 'inline-block', height: '8px', marginRight: '6px', width: '8px' }} />
                                      )}
                                      {value?.isSendBeforeMail && (
                                        <span style={{ backgroundColor: 'green', borderRadius: '50%', display: 'inline-block', height: '8px', marginRight: '6px', width: '8px' }} />
                                      )}
                                      {value.name}
                                      {value.age && (
                                        <span className="text-muted font-weight-600 ml-2" style={{ fontSize: '12px' }}>({value.age} yrs)</span>
                                      )}
                                      {value.grade && (
                                        <span className="text-muted font-weight-600 ml-2" style={{ fontSize: '12px' }}>· {value.grade}</span>
                                      )}
                                    </h4>
                                    <div className="d-flex flex-column mt-1" style={{ gap: '4px' }}>
                                      <a href={`mailto:${value.email}`} className="text-primary font-weight-600" style={{ fontSize: '12.5px', textDecoration: 'none' }}>
                                        <i className="fa fa-envelope mr-1 text-muted" style={{ fontSize: '10.5px' }} />
                                        {value.email}
                                      </a>
                                      {value.mobile && (
                                        <a href={`tel:${value.mobile}`} className="text-primary font-weight-600" style={{ fontSize: '12.5px', textDecoration: 'none' }}>
                                          <i className="fa fa-phone mr-1 text-muted" style={{ fontSize: '10.5px' }} />
                                          {value.mobile}
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    {(userType === 'admin' || userType === 'sub_admin') && (
                                      <UncontrolledDropdown>
                                        <DropdownToggle
                                          className='btn-icon-only text-light mr-n2'
                                          href='JavaScript:Void(0);'
                                          role='button'
                                          size='sm'
                                          color=''
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          <i className='fas fa-ellipsis-v' />
                                        </DropdownToggle>
                                        <DropdownMenu className='dropdown-menu-arrow' right>
                                          <DropdownItem href='JavaScript:Void(0);' onClick={() => this.editNotification(index)}>
                                            Edit
                                          </DropdownItem>
                                          <DropdownItem href='JavaScript:Void(0);' onClick={() => this.deleteNotification(index)}>
                                            Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    )}
                                  </div>
                                </div>

                                {/* Section/Class Box */}
                                <div className="mb-3 p-2.5" style={{ backgroundColor: '#f8f9fe', border: '1px solid #f1f3f9', borderRadius: '10px' }}>
                                  <div className="row">
                                    <div className="col-7">
                                      <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Class Name</span>
                                      <span className="font-weight-700 text-dark" style={{ fontSize: '13px' }}>{className || 'No Class'}</span>
                                    </div>
                                    <div className="col-5 text-right">
                                      <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Created By</span>
                                      <span className="badge badge-secondary font-weight-700" style={{ fontSize: '10px' }}>{value?.createdBy?.toUpperCase() || 'SYSTEM'}</span>
                                    </div>
                                  </div>
                                </div>

                                {/* Timing Details Grid */}
                                <div className="row mb-3" style={{ rowGap: '12px' }}>
                                  <div className="col-6">
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Start Time</span>
                                    <div style={{ color: '#525f7f', fontSize: '12px', fontWeight: '600' }}>
                                      <i className="fa fa-calendar-alt mr-1 text-muted" style={{ fontSize: '10px' }} />
                                      {value.startTime ? moment(value.startTime).format('ll hh:mm A') : 'N/A'}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Time Zone</span>
                                    <div style={{ color: '#525f7f', fontSize: '12px', fontWeight: '600' }}>
                                      <i className="fa fa-globe mr-1 text-muted" style={{ fontSize: '10px' }} />
                                      {value?.timezone || 'N/A'}
                                    </div>
                                  </div>
                                </div>

                                {/* Delivery Status Container */}
                                <div className="p-2 mb-3" style={{ backgroundColor: '#fcfcfd', border: '1px dashed #e9ecef', borderRadius: '8px' }}>
                                  <div className="row">
                                    <div className="col-6" style={{ borderRight: '1px solid #f1f3f9' }}>
                                      <span className="text-muted font-weight-700 text-uppercase d-block mb-1" style={{ fontSize: '8.5px', letterSpacing: '0.8px' }}>Before Class</span>
                                      <div className="d-flex flex-column" style={{ fontSize: '10.5px', gap: '4px' }}>
                                        <div className="d-flex justify-content-between pr-2">
                                          <span className="text-muted">1hr:</span>
                                          <span className={value.isDeliveredBefore10Min ? 'text-danger font-weight-700' : 'text-primary font-weight-700'}>
                                            {value.isDeliveredBefore10Min ? 'Delivered' : 'Pending'}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between pr-2">
                                          <span className="text-muted">24hr:</span>
                                          <span className={value.isDeliveredBefore24hr ? 'text-danger font-weight-700' : 'text-primary font-weight-700'}>
                                            {value.isDeliveredBefore24hr ? 'Delivered' : 'Pending'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <span className="text-muted font-weight-700 text-uppercase d-block mb-1" style={{ fontSize: '8.5px', letterSpacing: '0.8px' }}>After Class</span>
                                      <div className="d-flex flex-column" style={{ fontSize: '10.5px', gap: '4px' }}>
                                        <div className="d-flex justify-content-between pl-2">
                                          <span className="text-muted">1Min:</span>
                                          <span className={value.isDelivered10Min ? 'text-danger font-weight-700' : 'text-primary font-weight-700'}>
                                            {value.isDelivered10Min ? 'Delivered' : 'Pending'}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between pl-2">
                                          <span className="text-muted">24hr:</span>
                                          <span className={value.isDelivered24hr ? 'text-danger font-weight-700' : 'text-primary font-weight-700'}>
                                            {value.isDelivered24hr ? 'Delivered' : 'Pending'}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between pl-2">
                                          <span className="text-muted">72hr:</span>
                                          <span className={value.isDelivered72hr ? 'text-danger font-weight-700' : 'text-primary font-weight-700'}>
                                            {value.isDelivered72hr ? 'Delivered' : 'Pending'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Status Selector Dropdown */}
                                <div className="mb-3">
                                  <span className="text-muted font-weight-700 text-uppercase d-block mb-1.5" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Update Status</span>
                                  <Select
                                    options={allNotificationStatus}
                                    placeholder="Select Notification Status"
                                    isSearchable={true}
                                    menuPosition={'fixed'}
                                    menuPlacement={'bottom'}
                                    styles={{
                                      control: styles => ({ ...styles, borderRadius: '8px', width: '100%' }),
                                      menu: styles => ({ ...styles, borderRadius: '8px', width: '100%', zIndex: 9999 }),
                                    }}
                                    onChange={(e) => this.handleNotificationStatusChange(e, index)}
                                    value={allNotificationStatus.find(option => option.value == value.notificationStatus)}
                                  />
                                </div>

                                {/* Call, Chat & Action Hub */}
                                <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: '8px' }}>
                                  {(userType === 'admin' || userType === 'sub_admin') && (
                                    <>
                                      {userStateForMessage === 'Connecting' || userStateForMessage === 'On call' ? (
                                        <Button
                                          color="danger"
                                          size="sm"
                                          className="px-3 py-2 d-flex align-items-center"
                                          style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                          onClick={() => this.rejectCall(value.mobile)}
                                        >
                                          <i className="fa fa-phone-slash mr-1.5" /> Reject Call
                                        </Button>
                                      ) : (
                                        <Button
                                          color="success"
                                          size="sm"
                                          className="px-3 py-2 d-flex align-items-center"
                                          style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                          disabled={isActive}
                                          onClick={() => this.callInit(value, index)}
                                        >
                                          <i className="fa fa-phone mr-1.5" /> Call Client
                                        </Button>
                                      )}
                                    </>
                                  )}

                                  <Button
                                    color="info"
                                    size="sm"
                                    className="px-3 py-2 d-flex align-items-center"
                                    style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                    onClick={() => this.clientConnect(index)}
                                  >
                                    <i className="fa fa-comments mr-1.5" /> Chat Logs
                                  </Button>

                                  <Button
                                    color="neutral"
                                    size="sm"
                                    className="px-3 py-2 d-flex align-items-center text-success border-success"
                                    style={{ backgroundColor: '#fff', border: '1px solid', borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                    onClick={() => this.openDirectWhatsapp(value)}
                                  >
                                    <i className="fab fa-whatsapp mr-1.5" /> WhatsApp
                                  </Button>
                                </div>

                                {/* Action Buttons Footer (Reminders & Notes) */}
                                <div className="d-flex align-items-center pt-2 mb-3" style={{ borderTop: '1px solid #f1f3f9', gap: '8px' }}>
                                  {value.notificationStatus == 'Default' ? (
                                    <Button
                                      color="primary"
                                      size="sm"
                                      className="flex-fill py-2"
                                      style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                      onClick={() => this.sendReminder(value.notificationId, value.classId)}
                                    >
                                      Send Reminder
                                    </Button>
                                  ) : (
                                    <Button
                                      color="warning"
                                      size="sm"
                                      className="flex-fill py-2"
                                      style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                      disabled={!value.sendNotification}
                                      onClick={() => this.stopReminder(value.notificationId)}
                                    >
                                      {value.sendNotification ? 'Stop Reminder' : 'Stopped'}
                                    </Button>
                                  )}

                                  <Button
                                    color="default"
                                    size="sm"
                                    className="flex-fill py-2"
                                    style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                    onClick={() => this.addNotes(index)}
                                  >
                                    Add Notes
                                  </Button>
                                </div>

                                {value.notes && (
                                  <div style={{ marginTop: '6px', marginBottom: '4px', fontSize: '11px', color: '#525f7f', backgroundColor: '#f6f9fc', border: '1px solid #e9ecef', borderRadius: '6px', padding: '6px 10px', wordBreak: 'break-word' }}>
                                    <strong style={{ fontSize: '10px', textTransform: 'uppercase', color: '#8898aa' }}>Notes</strong>
                                    <div style={{ marginTop: '2px' }}>{value.notes}</div>
                                  </div>
                                )}

                                {/* Session Start Action & Timeline feed */}
                                <div className="mt-2 pt-2" style={{ borderTop: '1px dashed #e9ecef' }}>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    block
                                    className="py-2.5 mb-2 d-flex align-items-center justify-content-center"
                                    style={{ borderRadius: '10px', fontSize: '12px', fontWeight: '700' }}
                                    onClick={() => this.startClass(index)}
                                  >
                                    <i className="fa fa-play mr-1.5" /> Start Session
                                  </Button>

                                  {/* Timeline visual display */}
                                  {value.started_at && value.started_at.length > 0 ? (
                                    <div className="mt-2" style={{ width: '100%' }}>
                                      <span className="badge badge-dot mr-4">
                                        <i className="bg-success" style={{ height: '8px', width: '8px' }} />
                                        <span className="status font-weight-700 text-success" style={{ fontSize: '11px' }}>
                                          Started ({value.started_at.length}x)
                                        </span>
                                      </span>
                                      <div
                                        className="shadow-sm mt-1"
                                        style={{
                                          backgroundColor: '#fbfcfd',
                                          border: '1px solid rgba(0,0,0,.05)',
                                          borderRadius: '6px',
                                          maxHeight: '110px',
                                          overflowY: 'auto',
                                          padding: '8px 10px',
                                        }}
                                      >
                                        {value.started_at.map((start, i) => (
                                          <div
                                            key={i}
                                            className="d-flex align-items-center mb-1 pb-1"
                                            style={{
                                              borderBottom: i < value.started_at.length - 1 ? '1px dashed #e9ecef' : 'none',
                                              fontSize: '11px',
                                            }}
                                          >
                                            <i className="fa fa-user text-muted mr-1" style={{ fontSize: '10px' }} />
                                            <strong className="text-primary mr-1" style={{ fontSize: '10.5px' }}>
                                              {start.teacherId || 'Teacher'}
                                            </strong>
                                            <span className="text-muted ml-auto">
                                              {moment(start.startedAt).format('h:mm A')}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  ) : (
                                    value.startClassTime && (
                                      <div className="mt-2">
                                        <span className="badge badge-dot mr-4">
                                          <i className="bg-success" style={{ height: '8px', width: '8px' }} />
                                          <span className="status text-success font-weight-600" style={{ fontSize: '11px' }}>
                                            Started: {moment(value.startClassTime).format('hh:mm A')}
                                          </span>
                                        </span>
                                      </div>
                                    )
                                  )}
                                </div>
                              </CardBody>
                            </Card>
                          );
                        })
                      ) : (
                        <div className="text-center py-4 bg-white rounded-lg shadow-sm">
                          <h4 className="text-muted mb-0">No notifications found</h4>
                        </div>
                      )}
                    </div>

                    <CardFooter className='py-4'>
                      <nav aria-label='...'>
                        <Pagination
                          className='pagination justify-content-end mb-0'
                          listClassName='justify-content-end mb-0'
                        >
                          <PaginationItem
                            className={listPage > 1 ? '' : 'disabled'}
                          >
                            <PaginationLink
                              onClick={() => this.changePage('prev')}
                              tabIndex='-1'
                            >
                              <i className='fas fa-angle-left' />
                              <span className='sr-only'>Previous</span>
                            </PaginationLink>
                          </PaginationItem>

                          <PaginationItem className='active'>
                            <PaginationLink onClick={(e) => e.preventDefault()}>
                              {listPage}
                            </PaginationLink>
                          </PaginationItem>

                          <PaginationItem
                            className={totalNewPage > listPage ? '' : 'disabled'}
                          >
                            <PaginationLink onClick={() => this.changePage('next')}>
                              <i className='fas fa-angle-right' />
                              <span className='sr-only'>Next</span>
                            </PaginationLink>
                          </PaginationItem>
                        </Pagination>
                      </nav>
                    </CardFooter>
                  </Card>
                </div>
              </Row>

            </Container>
          </TabPane>
          <TabPane tabId='2'>
            <div className=''>
              <Card className='bg-secondary shadow border-0'>
                <CardBody className='px-lg-12 py-lg-12'>
                  <Form role='form' className={'justify-content-center'}>
                    <FormGroup className={classIdError ? 'has-danger' : ''}>
                      <InputGroup className="input-group-alternative" styles={{ width: '100%' }}>
                        <div style={{ width: "100%", minWidth: "200px" }}>
                          <Select
                            style={{ width: "100%", minWidth: "200px" }}
                            options={[
                              ...(classList &&
                                classList.map((item) => ({
                                  value: item.classId,
                                  label: item.name,
                                }))),
                            ]}
                            value={
                              classId && {
                                value: classId,
                                label: classList.find((item) => item.classId === classId).name,
                              }
                            }
                            placeholder="All Classes"
                            onChange={(e) => {
                              this.changeClassMessage(e.value);
                              this.setState({ classId: e.value })
                            }}
                            isSearchable={true}
                          />
                        </div>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup className={nameError ? 'has-danger' : ''}>
                      <div className="col-md-4 " >
                        <label className="">After 1 Min</label>
                        <Input className="col-md-10 form-group-input" name='subject10min'
                          onChange={(e) =>
                            this.setState({ subject10min: e.target.value })
                          }
                          value={subject10min}
                          placeholder="After 1 min subject" type="text" />
                        <textarea
                          placeholder='1 Mins'
                          cols={46}
                          rows={20}
                          name='message10min'
                          value={message10min}
                          onChange={(e) =>
                            this.setState({ message10min: e.target.value })
                          }
                        />
                        {/* Add here upload pdf file  */}
                        <FormGroup>
                          {
                            pdfLinkMessage10min &&
                            <div>
                              <a href={pdfLinkMessage10min} target={'_blank'}>{pdfLinkMessage10min}</a>
                            </div>

                            //     Add delete button here

                          }

                          <InputGroup className='input-group-alternative'>
                            <input
                              type='file'
                              name='image1'
                              id='myFile1'
                              ref={pdfRefs.input1}
                              onChange={(e) => fileChange(e, 'pdfLinkMessage10min', pdfRefs.input1)}
                              multiple={false}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <div className="col-md-4 " >
                        <label className="">After 24 Hr</label>
                        <Input className="col-md-10 form-group-input"
                          name='subject24hr'
                          onChange={(e) =>
                            this.setState({ subject24hr: e.target.value })
                          }
                          value={subject24hr}
                          placeholder="After 24 Hr subject"
                          type="text" />
                        <textarea
                          placeholder='24 Hrs'
                          cols={50}
                          rows={20}
                          name='message24hr'
                          value={message24hr}
                          onChange={(e) =>
                            this.setState({ message24hr: e.target.value })
                          }
                        />
                        <FormGroup>
                          {
                            pdfLinkMessage24hr &&
                            <a href={pdfLinkMessage24hr} target={'_blank'}>{pdfLinkMessage24hr}</a>
                          }

                          <InputGroup className='input-group-alternative'>
                            <input
                              type='file'
                              name='image'
                              id='myFile'
                              ref={pdfRefs.input5}
                              onChange={(e) => fileChange(e, 'pdfLinkMessage24hr', pdfRefs.input5)}
                              multiple={false}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <div className="col-md-4 " >
                        <label className="">After 72 Hr</label>
                        <Input className="col-md-10 form-group-input" name='subject72hr'
                          onChange={(e) =>
                            this.setState({ subject72hr: e.target.value })
                          }
                          value={subject72hr}
                          placeholder="After 72 Hr subject" type="text" />
                        <textarea
                          placeholder='72 Hrs'
                          cols={50}
                          rows={20}
                          name='message72hr'
                          value={message72hr}
                          onChange={(e) =>
                            this.setState({ message72hr: e.target.value })
                          }
                        />
                        <FormGroup>
                          {
                            pdfLinkMessage72hr &&
                            <a href={pdfLinkMessage72hr} target={'_blank'}>{pdfLinkMessage72hr}</a>
                          }

                          <InputGroup className='input-group-alternative'>
                            <input
                              type='file'
                              name='image'
                              id='myFile2'
                              ref={pdfRefs.input2}
                              onChange={(e) => fileChange(e, 'pdfLinkMessage72hr', pdfRefs.input2)}
                              multiple={false}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <div className="col-md-4 " >
                        <label className="">Before 1 hour</label>
                        <Input className="col-md-10 form-group-input" name='subjectBefore10min'
                          onChange={(e) =>
                            this.setState({ subjectBefore10min: e.target.value })
                          }
                          value={subjectBefore10min}
                          placeholder="Before 1 hour subject" type="text" />
                        <textarea
                          placeholder='1 hour Before'
                          cols={50}
                          rows={20}
                          name='message10minBefore'
                          value={messageBefore10min}
                          onChange={(e) =>
                            this.setState({ messageBefore10min: e.target.value })
                          }
                        />
                        <FormGroup>
                          {
                            pdfLinkMessageBefore10min &&
                            <a href={pdfLinkMessageBefore10min}>{pdfLinkMessageBefore10min}</a>
                          }

                          <InputGroup className='input-group-alternative'>
                            <input
                              type='file'
                              name='image'
                              id='myFile3'
                              ref={pdfRefs.input3}
                              onChange={(e) => fileChange(e, 'pdfLinkMessageBefore10min', pdfRefs.input3)}
                              multiple={false}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <div className="col-md-4 " >
                        <label className="">Before 24 Hrs</label>
                        <Input className="col-md-10 form-group-input" name='subjectBefore24hr'
                          onChange={(e) =>
                            this.setState({ subjectBefore24hr: e.target.value })
                          }
                          value={subjectBefore24hr}
                          placeholder="Before 24 hr subject" type="text" />
                        <textarea
                          placeholder='24 Hrs Before'
                          cols={50}
                          rows={20}
                          name='messageBefore24hr'
                          value={messageBefore24hr}
                          onChange={(e) =>
                            this.setState({ messageBefore24hr: e.target.value })
                          }
                        />
                        <FormGroup>
                          {
                            pdfLinkMessageBefore24hr &&
                            <a href={pdfLinkMessageBefore24hr}>{pdfLinkMessageBefore24hr}</a>
                          }

                          <InputGroup className='input-group-alternative'>
                            <input
                              type='file'
                              name='image'
                              id='myFile4'
                              ref={pdfRefs.input4}
                              onChange={(e) => fileChange(e, 'pdfLinkMessageBefore24hr', pdfRefs.input4)}
                              multiple={false}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </FormGroup>
                    <div className='text-center'>
                      <Button
                        disabled={uploading}
                        className='my-4'
                        color='primary'
                        type='button'
                        onClick={() => {
                          this.updateNotificationMessage();
                        }}
                      >Update
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </TabPane>
          <TabPane tabId='3'>
            <Container fluid>
              {/* Table */}
              <Row>
                <div className='col'>
                  <Card className='shadow'>
                    <CardHeader className='border-0'>
                      <h3 className='mb-0'>Sales Users</h3>
                    </CardHeader>
                    <Table
                      className='align-items-center table-flush cp;'
                      responsive
                      style={{ marginBottom: '100px' }}
                    >
                      <thead className='thead-light'>
                        <tr>
                          <th scope='col'>User name</th>
                          <th scope='col'>Email</th>
                          <th scope='col'>Zoom Link</th>
                          <th scope='col'>Status</th>

                          {/*<th scope='col'>Notification Sent</th>*/}
                          <th scope='col' />
                        </tr>
                      </thead>
                      <tbody>
                        {allSalesUser &&
                          allSalesUser.map((value, index) => {
                            return (
                              value.isActive && (
                                <tr key={index}>
                                  <td className={'table-column-width'}>{value.name}</td>
                                  <td className={'table-column-width'}>{value.email}</td>
                                  <td className={'table-column-width'}>{value.zoomLink}</td>
                                  <td className={'table-column-width'}>{value.isActive ? 'Active' : 'Inactive'}</td>
                                  <td className={'table-column-width'}>
                                    <UncontrolledDropdown>
                                      <DropdownToggle
                                        className='btn-icon-only text-light'
                                        href='JavaScript:Void(0);'
                                        role='button'
                                        size='sm'
                                        color=''
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <i className='fas fa-ellipsis-v' />
                                      </DropdownToggle>
                                      <DropdownMenu
                                        className='dropdown-menu-arrow'
                                        right
                                      >
                                        <DropdownItem
                                          href='JavaScript:Void(0);'
                                          onClick={() => this.editSalesUsers(index)}
                                        >
                                          Edit
                                        </DropdownItem>
                                        <DropdownItem
                                          href='JavaScript:Void(0);'
                                          onClick={() => this.deleteNotification(index)}
                                        >
                                          Delete
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </td>
                                </tr>
                              )
                            );
                          })}
                      </tbody>
                    </Table>

                    <CardFooter className='py-4'>
                      <nav aria-label='...'>
                        <Pagination
                          className='pagination justify-content-end mb-0'
                          listClassName='justify-content-end mb-0'
                        >
                          <PaginationItem
                            className={listPage > 1 ? '' : 'disabled'}
                          >
                            <PaginationLink
                              onClick={() => this.changePageSale('prev')}
                              tabIndex='-1'
                            >
                              <i className='fas fa-angle-left' />
                              <span className='sr-only'>Previous</span>
                            </PaginationLink>
                          </PaginationItem>

                          <PaginationItem className='active'>
                            <PaginationLink onClick={(e) => e.preventDefault()}>
                              {listPageSale}
                            </PaginationLink>
                          </PaginationItem>

                          <PaginationItem
                            className={totalNewPageSale > listPageSale ? '' : 'disabled'}
                          >
                            <PaginationLink onClick={() => this.changePageSale('next')}>
                              <i className='fas fa-angle-right' />
                              <span className='sr-only'>Next</span>
                            </PaginationLink>
                          </PaginationItem>
                        </Pagination>
                      </nav>
                    </CardFooter>
                  </Card>
                </div>
              </Row>

            </Container>
          </TabPane>

          <TabPane tabId='4'>
            <Container fluid>
              {/* Table */}
              <Row>
                <div className='col'>
                  <Card className='shadow'>
                    <CardHeader className='border-0'>
                      <h3 className='mb-0'>Duplicates</h3>
                    </CardHeader>
                    <Table
                      className='align-items-center table-flush cp;'
                      responsive
                      style={{ marginBottom: '100px' }}
                    >
                      <thead className='thead-light'>
                        <tr>
                          <th scope='col'>User name</th>
                          <th scope='col'>Email</th>
                          <th scope='col'>Age</th>
                          <th scope='col'>Count</th>
                          <th scope='col' />
                        </tr>
                      </thead>
                      <tbody>
                        {duplicatesNotification &&
                          duplicatesNotification.map((value, index) => {
                            return (
                              <tr key={index}>
                                <td className={'table-column-width'}>{value.name}</td>
                                <td className={'table-column-width'}>{value.email}</td>
                                <td className={'table-column-width'}>{value.age}</td>
                                <td className={'table-column-width'}>{value.count}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>

                    <CardFooter className='py-4'>
                    </CardFooter>
                  </Card>
                </div>
              </Row>

            </Container>
          </TabPane>

        </TabContent>

        <AddTrialModal
          isOpen={this.state.addTrialModal}
          classList={classList}
          onClose={() => this.setState({ addTrialModal: false })}
          onSaved={() =>
            this.setState(
              { addTrialModal: false, successModal: true, modalTitle: 'Success', message: 'Trial class added.' },
              () => this.getSalesNotification()
            )
          }
        />
        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={notificationModal || editModal}
          toggle={() =>
            this.toggleModal(notificationModal ? 'notificationModal' : 'editModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center mt-2 mb-3'>
                  <small>{notificationModal ? 'Add new notification' : 'Edit Notification'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={classIdError ? 'has-danger' : ''}>
                    <InputGroup className="input-group-alternative" styles={{ width: '100%' }}>
                      <div style={{ width: "100%", minWidth: "200px" }}>
                        <Select
                          style={{ width: "100%", minWidth: "200px" }}
                          options={[
                            ...(classList &&
                              classList.map((item) => ({
                                value: item.classId,
                                label: item.name,
                              }))),
                          ]}
                          value={
                            classId && {
                              value: classId,
                              label: classList.find((item) => item.classId === classId).name,
                            }
                          }
                          placeholder="All Classes"
                          onChange={(e) => {
                            this.setState(
                              { classId: e.value }
                            );
                          }}
                          isSearchable={true}
                        />
                      </div>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className={createdByError ? 'has-danger' : ''}>
                    <InputGroup className="input-group-alternative" styles={{ width: '100%' }}>
                      <div style={{ width: "100%", minWidth: "200px" }}>
                        <Select
                          className="react-select react-select-primary"
                          placeholder={"Select Sales"}
                          options={[
                            { value: '', label: 'All' }, // "All" option
                            ...(allSalesUser &&
                              allSalesUser.map((item) => ({
                                value: item.name,
                                label: item.name,
                              }))),
                          ]}
                          value={
                            createdBy && {
                              value: createdBy,
                              label: allSalesUser.find((item) => item.name === createdBy).name,
                            }
                          }
                          onChange={(e) => { this.changeSales(e.value) }}
                        />
                      </div>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={nameError ? 'has-danger' : ''}>
                    <label>Name</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Name'
                        type='text'
                        name='name'
                        value={name}
                        onChange={(e) =>
                          this.setState({ name: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={emailError ? 'has-danger' : ''}>
                    <label>Email</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Email'
                        type='text'
                        name='email'
                        value={email}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={mobileError || (mobile && mobile[0] === '1') ? 'has-danger' : ''}>
                    <label>Mobile Number (No Dashes Or Spaces OR Country Code. US number only)</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Mobile Number'
                        ype='text'
                        name='mobile'
                        value={mobile}
                        onChange={(e) => {
                          const input = e.target.value.replace(/\D/g, '').slice(0, 15); // remove non-digits and
                          // limit to 10 digits
                          this.setState({ mobile: input });
                        }}
                      />
                    </InputGroup>
                    {mobileError && <div className="text-danger">Please enter a valid mobile number.</div>}
                    {mobile && mobile[0] === '1' && <div className="text-danger">Please enter a valid US mobile number (without country code).</div>}
                  </FormGroup>

                  <FormGroup >
                    <label>Zoom Link</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        disabled
                        placeholder='Zoom Link'
                        ype='text'
                        name='zoomLink'
                        value={zoomLinkSales}
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className='text-center'>
                    {uploading ? (
                      <span style={{ color: 'red' }}>Wait...</span>
                    ) : null}

                    <Button
                      disabled={uploading || loading ? true : false}
                      className='my-4'
                      color='primary'
                      type='button'
                      onClick={() => {
                        this.addOrUpdateNotification(notificationModal ? false : true);
                      }}
                    >
                      {notificationModal ? 'Save' : 'Update'}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={this.state.directWhatsappModal}
          toggle={() => this.setState({ directWhatsappModal: false })}
        >
          <div className='modal-header bg-success text-white d-flex align-items-center justify-content-between p-3' style={{ borderBottom: 'none', borderRadius: '4px 4px 0 0' }}>
            <h4 className="modal-title m-0 text-white font-weight-bold" style={{ fontSize: '1.1rem' }}>
              <i className="fab fa-whatsapp mr-2" style={{ fontSize: '1.3rem' }} /> Direct WhatsApp Message
            </h4>
            <button
              type="button"
              className="close text-white"
              style={{ opacity: '0.8', outline: 'none', border: 'none', background: 'transparent' }}
              onClick={() => this.setState({ directWhatsappModal: false })}
            >
              <span aria-hidden="true" style={{ fontSize: '1.5rem', color: '#fff' }}>&times;</span>
            </button>
          </div>
          <div className='modal-body bg-secondary p-4'>
            <Card className='shadow border-0 bg-white p-4'>
              <Form role='form'>
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                      <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Recipient Name</label>
                      <Input
                        type="text"
                        className="form-control-alternative font-weight-bold"
                        style={{ color: '#333', background: '#f5f6f7' }}
                        value={this.state.directWhatsappName}
                        onChange={(e) => this.setState({ directWhatsappName: e.target.value })}
                        placeholder="Recipient Name"
                      />
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                      <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Phone Number (with pincode)</label>
                      <div className="d-flex">
                        <Input
                          type="select"
                          className="form-control-alternative mr-2"
                          style={{ width: '120px', fontWeight: '600' }}
                          value={this.state.directWhatsappCountryCode}
                          onChange={(e) => this.setState({ directWhatsappCountryCode: e.target.value })}
                        >
                          <option value="+91">+91 (IN)</option>
                          <option value="+1">+1 (US/CA)</option>
                          <option value="+44">+44 (UK)</option>
                          <option value="+61">+61 (AU)</option>
                          <option value="+65">+65 (SG)</option>
                          <option value="+971">+971 (AE)</option>
                          <option value="+64">+64 (NZ)</option>
                          <option value="+33">+33 (FR)</option>
                          <option value="+49">+49 (DE)</option>
                          <option value="+81">+81 (JP)</option>
                          <option value="+82">+82 (KR)</option>
                          <option value="+60">+60 (MY)</option>
                          <option value="+62">+62 (ID)</option>
                          <option value="+852">+852 (HK)</option>
                        </Input>
                        <Input
                          type="text"
                          className="form-control-alternative font-weight-bold flex-grow-1"
                          value={this.state.directWhatsappNumber}
                          onChange={(e) => this.setState({ directWhatsappNumber: e.target.value })}
                          placeholder="Phone number"
                        />
                      </div>
                    </FormGroup>
                  </div>
                </div>

                <FormGroup className="mt-2">
                  <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Quick-Select Message Options</label>
                  <div className="d-flex flex-wrap gap-2 mb-3" style={{ gap: '8px' }}>
                    {WHATSAPP_TEMPLATES.map((tpl, idx) => {
                      const isSelected = this.state.directWhatsappTemplateIndex === idx;
                      return (
                        <Button
                          key={idx}
                          type="button"
                          size="sm"
                          color={isSelected ? "success" : "secondary"}
                          className="m-1"
                          style={{
                            borderRadius: '20px',
                            textTransform: 'none',
                            fontWeight: '600',
                            fontSize: '0.78rem',
                            border: isSelected ? '1px solid #28a745' : '1px solid #cad1d7',
                            boxShadow: isSelected ? '0 2px 4px rgba(40, 167, 69, 0.2)' : 'none',
                            transition: 'all 0.2s ease'
                          }}
                          onClick={() => this.handleTemplateChange(idx)}
                        >
                          {tpl.title}
                        </Button>
                      );
                    })}
                  </div>
                </FormGroup>

                <FormGroup>
                  <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Message Body</label>
                  <textarea
                    className="form-control form-control-alternative"
                    rows={5}
                    placeholder="Type your custom WhatsApp message here..."
                    value={this.state.directWhatsappMessage}
                    onChange={(e) => this.setState({ directWhatsappMessage: e.target.value, directWhatsappTemplateIndex: WHATSAPP_TEMPLATES.length - 1 })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #cad1d7',
                      borderRadius: '6px',
                      fontSize: '0.88rem',
                      lineHeight: '1.5',
                      color: '#2b2b2b'
                    }}
                  />
                </FormGroup>

                <div className="d-flex justify-content-end align-items-center mt-4">
                  <Button
                    color="secondary"
                    type="button"
                    onClick={() => this.setState({ directWhatsappModal: false })}
                    style={{ fontWeight: '600', borderRadius: '4px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="success"
                    type="button"
                    className="ml-2 px-4"
                    onClick={this.sendDirectWhatsapp}
                    disabled={this.state.loading}
                    style={{ fontWeight: '700', borderRadius: '4px', backgroundColor: '#2acb9d', borderColor: '#2acb9d' }}
                  >
                    {this.state.loading ? 'Sending...' : 'Send on WhatsApp'}
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Modal>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={notificationCallModal}
          toggle={() =>
            this.toggleModal('notificationCallModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center'>
                  <small>{'Send SMS Message'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        placeholder='Enter SMS Message...'
                        cols={100}
                        rows={5}
                        value={twillioMessage}
                        onChange={(e) =>
                          this.setState({ twillioMessage: e.target.value })
                        }
                        style={{ width: '100%', padding: '12px', border: '1px solid #cad1d7', borderRadius: '4px' }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className="row text-right">
                    <div className="ml-auto" style={{ marginRight: '10px' }}>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => this.setState({ notificationCallModal: !notificationCallModal })}
                      >
                        Cancel
                      </Button>
                      <Button
                        disabled={!!loading}
                        color="primary"
                        type="button"
                        onClick={() => this.replyMessageResponse()}
                      >
                        Send Message
                      </Button>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>


        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={notificationNotesModal}
          toggle={() =>
            this.toggleModal('notificationNotesModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center mt-2 mb-3'>
                  <small>{'Add Notes'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <label>Notes</label>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        placeholder='Enter notes'
                        cols={100}
                        rows={5}
                        value={notes}
                        onChange={(e) =>
                          this.setState({ notes: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className='text-center'>
                    {uploading ? (
                      <span style={{ color: 'red' }}>Wait...</span>
                    ) : null}

                    <Button
                      disabled={uploading || loading ? true : false}
                      className='my-4'
                      color='primary'
                      type='button'

                      onClick={() => {
                        this.updateNotificationNotes();
                      }}
                    >
                      {'Save'}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={editSalesModal}
          toggle={() =>
            this.toggleModal('editSalesModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center mt-2 mb-3'>
                  <small>{'Edit Sales User'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={nameError ? 'has-danger' : ''}>
                    <label>Name</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Name'
                        type='text'
                        name='name'
                        value={name}
                        onChange={(e) =>
                          this.setState({ name: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={emailError ? 'has-danger' : ''}>
                    <label>Email</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Email'
                        type='text'
                        name='email'
                        value={email}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={emailError ? 'has-danger' : ''}>
                    <label>Zoom Link</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Zoom Link'
                        type='text'
                        name='zoomLink'
                        value={zoomLink}
                        onChange={(e) =>
                          this.setState({ zoomLink: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <label>Map with Coach</label>
                    <InputGroup className='input-group-alternative'>
                      <Select
                        className={styles['custom-select'] + styles['rbc-event-label']}
                        styles={customStyles} // Apply the custom styles
                        options={teachersList}
                        value={teachersList && teachersList.find((option) => option.value === teacherId) || ''}
                        placeholder="All Coaches"
                        isSearchable={true}
                        onChange={(e) => {
                          this.setState(
                            { filterTeacher: e.value, page: 1, teacherId: e.value, teacherName: e.label, teacherTimezone: e.timeZone },
                            () => {
                            }
                          );
                        }}
                      />
                    </InputGroup>
                  </FormGroup>


                  <div className='text-center'>
                    {uploading ? (
                      <span style={{ color: 'red' }}>Wait...</span>
                    ) : null}

                    <Button
                      disabled={uploading || loading ? true : false}
                      className='my-4'
                      color='primary'
                      type='button'
                      onClick={() => {
                        this.UpdateSalesUser();
                      }}
                    >
                      {'Update'}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>


        <Modal
          className='modal-dialog-centered'
          isOpen={this.state.successModal || this.state.errorModal}
          toggle={() =>
            successModal
              ? this.toggleModal('successModal')
              : errorModal
                ? this.toggleModal('errorModal')
                : null
          }
        >
          <div className='modal-header'>
            <h5 className='modal-title' id='successModalLabel'>
              {modalTitle}
            </h5>
            <button
              aria-label='Close'
              className='close'
              data-dismiss='modal'
              type='button'
              onClick={() =>
                successModal
                  ? this.toggleModal('successModal')
                  : errorModal
                    ? this.toggleModal('errorModal')
                    : null
              }
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          {this.state.successModal ? (
            <div className='modal-body' style={{ color: 'green' }}>
              {message}
            </div>
          ) : this.state.errorModal ? (
            <div className='modal-body' style={{ color: 'red' }}>
              {message}
            </div>
          ) : null}
          <div className='modal-footer'>
            <Button
              color='primary'
              type='button'
              onClick={() =>
                successModal
                  ? this.toggleModal('successModal')
                  : errorModal
                    ? this.toggleModal('errorModal')
                    : null
              }
            >
              Ok
            </Button>
          </div>
        </Modal>

      </>
    );
  }
}

export default SalesNotification;
